var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useEffect, useContext } from 'react';
import AppContext from '../../../../context';
import { FormWrapper } from '../../form-wrapper';
import { InputFiled, ColorPicker, Position, InputNumberFiled, Size } from './fields';
import { prefix } from './constants';
var GroupComponent = function (props) {
    var config = props.config, _a = props.plugin, plugin = _a === void 0 ? {} : _a;
    var updateGroup = plugin.updateGroup;
    var NodeConfig = useContext(AppContext).theme.NodeConfig;
    var _b = useState(__assign(__assign({}, NodeConfig.normal), config)), groupConfig = _b[0], setGroupConfig = _b[1];
    var onGroupConfigChange = function (key, value) {
        var _a, _b;
        setGroupConfig(__assign(__assign({}, groupConfig), (_a = {}, _a[key] = value, _a)));
        updateGroup((_b = {},
            _b[key] = value,
            _b));
    };
    useEffect(function () {
        setGroupConfig(__assign(__assign({}, NodeConfig.normal), config));
    }, [config]);
    return (React.createElement("div", { className: "".concat(prefix, "-panel-body") },
        React.createElement("div", { className: "".concat(prefix, "-panel-group") },
            React.createElement("h5", null, "\u5185\u5BB9"),
            React.createElement(InputFiled, { label: "\u6807\u9898", value: groupConfig.label, onChange: function (value) {
                    onGroupConfigChange('label', value);
                } })),
        React.createElement("div", { className: "".concat(prefix, "-panel-group") },
            React.createElement("h5", null, "\u6837\u5F0F"),
            React.createElement(Position, { x: groupConfig.x, y: groupConfig.y, onChange: function (key, value) {
                    onGroupConfigChange(key, value);
                } }),
            React.createElement(Size, { width: groupConfig.width, height: groupConfig.height, onChange: function (key, value) {
                    onGroupConfigChange(key, value);
                } }),
            React.createElement(ColorPicker, { label: "\u586B\u5145", value: groupConfig.fill, onChange: function (value) {
                    onGroupConfigChange('fill', value);
                } }),
            React.createElement(ColorPicker, { label: "\u8FB9\u6846", value: groupConfig.stroke, onChange: function (value) {
                    onGroupConfigChange('stroke', value);
                } }),
            React.createElement("div", { className: "".concat(prefix, "-node-text-style") },
                React.createElement(InputNumberFiled, { label: "\u5B57\u53F7", value: groupConfig.fontSize, width: 68, onChange: function (value) {
                        onGroupConfigChange('fontSize', value);
                    } }),
                React.createElement(ColorPicker, { value: groupConfig.fontFill, onChange: function (value) {
                        onGroupConfigChange('fontFill', value);
                    } })))));
};
export var GroupService = function (props) {
    return (React.createElement(FormWrapper, __assign({}, props), function (config, plugin) { return React.createElement(GroupComponent, __assign({}, props, { plugin: plugin, config: config })); }));
};
